import { defineStore } from "pinia";
import { mande } from "mande";
// const api = mande("http://localhost:3333");
const api = mande("https://api.desne.io");

export const useAuditStore = defineStore("audit", {
  state: () => ({
    isLoading: true,
    meterData: {
      customer: {
        businessname: "",
        mpan: "",
      },
      monthlyKWHConsumption: {},
      timeOfDayConsumption: {},
      halfHourChart: {},
      seasonalTrendChart: {},
      totalPerDayChart: {},
      totalPerDayMinMax: {},
      timeOfDayHeatmap: {},
      timeOfMonthHeatmap: {},
    },
  }),

  getters: {},

  actions: {
    async collectMeterData(key) {
      try {
        this.isLoading = true;
        const data = await api.get(`/insights/${key}`);
        this.meterData = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
  },
});
